// The satirical names the player reads (docs/story/names.md, data/names.json). Code asks for an element by the name
// it has in names.json, so a word can change in one place, and the copy lint checks every word before it ships.
import NAMES from '../../data/names.json';

interface Item { element: string; word: string; hi: string; states?: Record<string, string> }
const BY = new Map<string, Item>();
for (const g of (NAMES as { groups: { items: Item[] }[] }).groups) for (const it of g.items) BY.set(it.element, it);

/** The word for an element, or one of its states ("Stamina", "empty" -> "Ghee khatam"). Throws on a missing name. */
export function name(element: string, state?: string): string {
  const it = BY.get(element);
  if (!it) throw new Error(`names.json has no element "${element}"`);
  if (state === undefined) return it.word;
  const s = it.states?.[state];
  if (s === undefined) throw new Error(`names.json: "${element}" has no state "${state}"`);
  return s;
}

/**
 * The ghee under your feet (docs/plans/2026-10-19-fixes-round-1.md, A6): nothing while there is enough to start a jog,
 * and below that only the words "Ghee khatam", no bar. The level itself is the HUD's Ghee meter, always on screen.
 */
export const gheeUnderFeet = (st: number, minToStart: number): string | null => (st >= minToStart ? null : name('Stamina', 'empty'));
